import React, { useEffect, useRef } from "react";
import { Avatar, Flex, Text } from "@chakra-ui/react";

const Messages = ({ messages }:any) => {

  const AlwaysScrollToBottom = () => {
    const elementRef:any = useRef();
    useEffect(() => elementRef.current.scrollIntoView());
    return <div ref={elementRef} />;
  };

  return (
    <Flex className="border_div" w="100%" h="80%" overflowY={"scroll"} flexDirection="column" p="3" marginTop={5}>
      {messages.map(
        (
          item: {
            from: string;
            date_time:string;
            text:
              | string
              | number
              | boolean
              | React.ReactElement<
                  any,
                  string | React.JSXElementConstructor<any>
                >
              | React.ReactFragment
              | null
              | undefined;
          },
          index: React.Key | null | undefined
        ) => {
          if (item.from === "EXPERT") {
            return (
              <Flex key={index} w="100%" justify="flex-end">
                 <Flex flexDirection="column">
                <Flex
                  bg="black"
                  color="white"
                  minW="100px"
                  maxW="350px"
                  my="1"
                  p="3"
                >
                  <Text>{item.text}</Text>
                </Flex>
                <Text fontSize="sm" color="gray.500">
              {item.date_time}
            </Text>
              </Flex>
              </Flex>
            );
          } else {
            return (
              <Flex key={index} w="100%">
                <Avatar
                  name="USER"
                  src="/img/user.png"
                  bg="white.300"
                ></Avatar>
                <Flex flexDirection="column">
                <Flex
                  bg="gray.100"
                  color="black"
                  minW="100px"
                  maxW="350px"
                  my="1"
                  p="3"
                >
                  <Text>{item.text}</Text>
                </Flex>
              <Text fontSize="sm" color="gray.500">
              {item.date_time}
            </Text>
              </Flex>
            </Flex>
            );
          }
        }
      )}
      <AlwaysScrollToBottom />
    </Flex>
  );
};

export default Messages;
